

export  const Answer=[
    ["1",
     "ans",
     "dummy",
     "dummy",
     "dummy"
],
    ["2",
        "dummy",
        "ans",
        "dummy",
        "dummy"
    ],["3",
        "dummy",
        "ans",
        "dummy",
        "dummy"
    ],
       ["4",
       "ans",
        "dummy",
        "dummy",
        "dummy"
       ]

]

